// extracted by mini-css-extract-plugin
export default {"wrapper":"tr-z","response":"ur-z","error":"vr-z","disabled":"wr-z","buttons":"xr-z","feedbackQuestionSection":"yr-z","yesNoWrapper":"zr-z"};